<template>
  <div class="banner">
    <router-link to="/" class="logo-link" tag="div">
      <img class="logo" src="http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/logo.png">
    </router-link>
    <ul class="box">
      <router-link to="/" class="items" active-class="active" tag="li" exact>首页</router-link>
      <router-link to="/products" class="items products_box" active-class="active" @mouseenter.native="show" @mouseleave.native="hide" tag="li">
        方案
        <i></i>
        <ul class="products_lists" v-show="listsShow">
          <router-link to="/products/oneMachine" class="digital" tag="li">云幕</router-link>
          <router-link to="/products/atenCamera" class="virtual" tag="li">云千目</router-link>
        </ul>
      </router-link>
      <router-link to="/CustomerCase" class="items" active-class="active" tag="li" exact>
        客户案例
      </router-link>
      <!-- <li class="items"> -->
        <!-- <a href="http://ym.bridgetek.cn/" target="_blank" >
          云幕平台 -->
      <!-- </li> -->
      <router-link to="/NewsLists" class="items" active-class="active" tag="li" exact>
        公司资讯
      </router-link>
      <router-link to="/aboutUs" class="items" active-class="active" tag="li" exact>
        关于我们
      </router-link>
      <router-link to="/Contact" class="items" active-class="active" tag="li" exact>
        联系我们
      </router-link>
      <!-- <router-link to="/AccessPlatform" class="items" active-class="active" tag="li" exact>进入平台</router-link> -->
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // isSelected: "HomeMain",
      listsShow: false
    };
  },
  methods: {
    show() {
      this.listsShow = true
    },
    hide() {
      this.listsShow = false
    },
    refresh() {
      window.location.reload();
    }
  },
  watch: {
    $route(to,from){
      this.listsShow = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  font-size: 14px;
  color: #505050;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

a {
  text-decoration: none;
  color: #505050;
}

a:hover {
  color: #f39800;
}

.box {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.logo-link {
  width: auto;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.items {
  height: 100%;
  list-style: none;
  padding: 0 30px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

.items:hover, .items:hover a {
  background: #f39800;
  color: #fff;
}

.items > i {
  width: 12px;
  height: 12px;
  margin-left: 10px;
  background: url("http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/arrow-down.png") no-repeat 0 3px;
}

.items:hover > i {
  background: url("http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/arrow-down-white.png") no-repeat 0px 3px;
}

.active {
  color: #f39800;
}

.products_box {
  position: relative;
}

.products_lists {
  width: 110px;
  height: 70px;
  color: #505050;
  text-indent: 18px;
  position: absolute;
  left: 0;
  bottom: -70px;
  z-index: 2;
  background: #fff;
}

.products_lists li {
  width: 100%;
  height: 50%;
  line-height: 35px;
}

.products_lists li:hover {
  color: #f39800;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue